import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import CheckIcon from "@material-ui/icons/Check";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import { graphqlUrl } from "utils/config";
import "./superShops.css";

/**
 * Shared pieces for the Shops and Restaurants screens, the same way
 * superAdminViews/ride/detailFields.js serves that group. Each of the
 * shop screens previously hand-rolled its own label/value rows, its own
 * star rendering and its own image lightbox.
 */

export const DetailField = ({ label, value, wide }) => {
  if (value === null || value === undefined || value === "") return null;
  return (
    <div className={`superShopField ${wide ? "isWide" : ""}`}>
      <span className="superShopLabel">{label}</span>
      <span className="superShopValue">{value}</span>
    </div>
  );
};

export const CopyableField = ({ label, value, wide }) => {
  const [copied, setCopied] = useState(false);
  if (!value) return null;

  const handleCopy = () => {
    if (!navigator.clipboard) return;
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <div className={`superShopField ${wide ? "isWide" : ""}`}>
      <span className="superShopLabel">{label}</span>
      <span className="superShopValueRow">
        <span className="superShopMono">{value}</span>
        <IconButton size="small" className="superShopCopyButton" onClick={handleCopy} title="Copy">
          {copied ? <CheckIcon fontSize="small" /> : <FileCopyIcon style={{ fontSize: 16 }} />}
        </IconButton>
      </span>
    </div>
  );
};

export const Stars = ({ value, showValue = true }) => {
  if (value === null || value === undefined || value === 0) {
    return <span className="superShopMuted">Not rated</span>;
  }
  const rounded = Math.round(value);
  return (
    <span className="superShopRating">
      <span className="superShopStars">
        {[1, 2, 3, 4, 5].map((star) =>
          star <= rounded ? <StarIcon key={star} /> : <StarBorderIcon key={star} className="isEmpty" />
        )}
      </span>
      {showValue && <span className="superShopRatingValue">{Number(value).toFixed(1)}</span>}
    </span>
  );
};

export const ImageStrip = ({ label, urls, wide }) => {
  const list = (urls || []).filter(Boolean);
  if (!list.length) return null;
  return (
    <div className={`superShopField ${wide ? "isWide" : ""}`}>
      <span className="superShopLabel">{label}</span>
      <span className="superShopImages">
        {list.map((url, index) => (
          <a
            key={`${url}-${index}`}
            className="superShopImageButton"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title="Open full size"
          >
            <img src={url} alt={`${label} ${index + 1}`} />
          </a>
        ))}
      </span>
    </div>
  );
};

// Uploaded assets are stored as a path relative to the API host.
export const assetUrl = (path) =>
  !path ? null : /^https?:\/\//i.test(path) ? path : `${graphqlUrl}${path.startsWith("/") ? "" : "/"}${path}`;

export const readableError = (error) => {
  if (!error) return "Something went wrong.";
  if (error.graphQLErrors && error.graphQLErrors.length > 0) return error.graphQLErrors[0].message;
  return error.message || "Something went wrong.";
};

export const humanize = (value) => (value ? String(value).replace(/_/g, " ").toLowerCase() : "");
